import { injectable } from "inversify";
import EventScheduleEntity from "../../entities/EventScheduleEntity";
import { Either, left } from "fp-ts/lib/Either";
import ExceptionEntity from "../../entities/ExceptionEntity";
import CalendarRepository from "../../repositories/CalendarRepository";
import TrackingTimeProvider from "../../providers/trackingTime/TrackingTimeProvider";
import UserProvider from "../../providers/user/UserProvider";
import KeyWordLocalization from "../../../ui/providers/localization/dictionaries/KeyWordLocalization";
import GetTodayTrackingCalendarUseCase, { GetTodayTrackingCalendarUseCaseName } from "../trackingTime/GetTodayTrackingCalendarUseCase";
import di from "../../../di/DependencyInjection";

interface props {
    calendarRepository: CalendarRepository;
    trackingTimeProvider: TrackingTimeProvider;
    userProvider: UserProvider;
}

@injectable()
export default class EditEventInCalendarUseCase {
    _calendarRepository: CalendarRepository;
    _trackingTimeProvider: TrackingTimeProvider;
    _userProvider: UserProvider;

    constructor(_: props) {
        this._calendarRepository = _.calendarRepository;
        this._trackingTimeProvider = _.trackingTimeProvider;
        this._userProvider = _.userProvider;
    }

    public call = async (event: EventScheduleEntity, userId: string): Promise<Either<ExceptionEntity, EventScheduleEntity>> => {
        const myUser = this._userProvider.Actions.user;
        const havePermission = (userId != myUser?.id && myUser?.permissions?.calendar.others_calendar.update) || (userId == myUser?.id && myUser?.permissions?.calendar.my_calendar.update);
        if (!havePermission) return left({ code: KeyWordLocalization.UserNotAuthorized });

        //edit
        const response = await this._calendarRepository.updateEvent(event, userId);
        const eventIsToday = event.dateStart.toDateString() === new Date().toDateString();
        if (eventIsToday && myUser?.id == userId)
            di.get<GetTodayTrackingCalendarUseCase>(GetTodayTrackingCalendarUseCaseName).call();
        return response;
    }
}

export const EditEventInCalendarUseCaseName = "EditEventInCalendarUseCaseName";
